import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const pplVersionHistorySlice = createSlice({
  name: 'pplVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default pplVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = pplVersionHistorySlice.actions;
